import RepositoryBase, {IFindOption} from "@/repositories/repository-base";

export class InquiryRepository extends RepositoryBase<any> {
  protected endpoint = "inquiries";
  protected ctor:new(data) => any = Object;
}
export default new InquiryRepository;
